import React from "react";
import Layout from "../components/Layout";

const Clients = () => {
  return (
    <Layout>
      <div className="page-container">
        <h1>Clients</h1>
        <p>Manage and view client information.</p>
      </div>
    </Layout>
  );
};

export default Clients;
